import { SET_USER_ROLE_DATA } from "../../actionTypes/userRole";

export function setUserRoleData({ isResident, redirectUrl }: any) {
  return { type: SET_USER_ROLE_DATA, payload: { isResident, redirectUrl } };
}
